import { Controller } from '@hotwired/stimulus'
import snackbarCheckImg from 'images/admin/org/snackbar-check.svg'
import { Toast } from 'bootstrap'
import * as liveRegion from '../../helpers/live_region_helper'

export default class extends Controller {
  connect() {
    this.handleToastMessage = this.handleToastMessage.bind(this)
    this.liveRegion = liveRegion.polite
    document.addEventListener('toast', this.handleToastMessage)
  }

  disconnect() {
    document.removeEventListener('toast', this.handleToastMessage)
  }

  handleToastMessage = (event) => {
    let toastTemplate = `
    <div class="toast hide ${event.detail.failure ? 'failure' : ''}" data-bs-delay="${event.detail.delay || 7000}">
      <div class="d-flex">
        ${this.handleToastImg(event)}
        <div class="${event.detail.failure ? '' : 'ms-2'}">
          ${event.detail.message}
        </div>
      </div>
    </div>
    `
    document.querySelectorAll('.toast').forEach(el => el.remove())
    this.liveRegion.setContent(event.detail.message)
    document.body.insertAdjacentHTML('beforeend', toastTemplate)
    const toastEl = document.querySelector('.toast')
    const toast = new Toast(toastEl)
    toast.show()
  }

  handleToastImg(event) {
    return event.detail.failure ? '' : `<img src="${snackbarCheckImg}" alt=""></img>`
  }
}
